import { useEffect } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface TradeIdFieldProps {
  placeholder?: string
}

export const TradeIdField: React.FC<TradeIdFieldProps> = ({ placeholder }) => {
  const { control, register, setValue } = useFormContext<{ trade_id: string | null }>()

  const [trade_id] = useWatch({ control, name: ['trade_id'] })

  useEffect(() => {
    if (trade_id === '') {
      setValue('trade_id', null, { shouldValidate: true })
    }
  }, [trade_id])

  return (
    <FormField
      name="trade_id"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Trade ID</FormLabel>
              <FormError />
            </div>
            <Input {...register('trade_id')} placeholder={placeholder ?? 'Enter a trade ID...'} />
          </FormItem>
        )
      }}
    />
  )
}
